import type React from 'react'
import type { ReactElement } from 'react'

export function IconUnstake(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={66} height={57} viewBox={'0 0 66 57'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
      <path
        d={
          'M34.0507 0.439339C33.4649 -0.146446 32.5151 -0.146446 31.9293 0.439339L22.3834 9.98528C21.7976 10.5711 21.7976 11.5208 22.3834 12.1066C22.9692 12.6924 23.9189 12.6924 24.5047 12.1066L32.99 3.62132L41.4753 12.1066C42.0611 12.6924 43.0108 12.6924 43.5966 12.1066C44.1824 11.5208 44.1824 10.5711 43.5966 9.98528L34.0507 0.439339ZM32.99 38.5L34.49 38.5L34.49 1.5L32.99 1.5L31.49 1.5L31.49 38.5L32.99 38.5Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M54 18.5C57.3137 18.5 60 21.1863 60 24.5V45.5L59.9922 45.8086C59.8367 48.8767 57.3767 51.3367 54.3086 51.4922L54 51.5H12L11.6914 51.4922C8.62332 51.3367 6.16325 48.8767 6.00781 45.8086L6 45.5V24.5C6 21.1863 8.68629 18.5 12 18.5H25V21.5H12C10.3431 21.5 9 22.8431 9 24.5V45.5C9 47.1569 10.3431 48.5 12 48.5H54C55.6569 48.5 57 47.1569 57 45.5V24.5C57 22.8431 55.6569 21.5 54 21.5H40V18.5H54Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M55.5664 12.5146C61.3783 12.8094 66 17.6148 66 23.5V45.5C66 51.3852 61.3783 56.1906 55.5664 56.4854L55 56.5H11C4.92487 56.5 0 51.5751 0 45.5V23.5C0 17.4249 4.92487 12.5 11 12.5H19V15.5H11C6.58172 15.5 3 19.0817 3 23.5V45.5C3 49.9183 6.58172 53.5 11 53.5H55C59.4183 53.5 63 49.9183 63 45.5V23.5C63 19.0817 59.4183 15.5 55 15.5H47V12.5H55L55.5664 12.5146Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
